import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api } from "../../lib/api";
import { EffSelect, Loading, ErrorState, Empty } from "./ui";

const STATUSES = ["Nouveau", "En cours", "Accepté", "Refusé", "Archivé"];

export default function SubmissionsPanel() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = async () => {
    setLoading(true);
    setError(false);
    try {
      const { data } = await api.get("/admin/submissions");
      setItems(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(true);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try { await api.patch(`/admin/submissions/${id}`, { status }); toast.success("Statut mis à jour"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Mise à jour impossible"); }
  };
  const remove = async (id) => {
    if (!window.confirm("Supprimer ?")) return;
    try { await api.delete(`/admin/submissions/${id}`); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Suppression impossible"); }
  };

  return (
    <div>
      <h2 className="font-display text-3xl mb-8">Formulaires — Inbox</h2>
      {loading ? <Loading /> : error ? <ErrorState onRetry={load} /> : (
      <div className="border-t border-[#292929]">
        {items.map((it, i) => (
          <div key={it.id} data-testid={`submission-${i}`} className="border-b border-[#292929] py-4 flex items-center gap-4">
            <div className="flex-1 min-w-0 cursor-pointer" onClick={() => setOpen(it)}>
              <div className="truncate">{it.name} · <span className="text-muted-eff">{it.project_name || "—"}</span></div>
              <div className="text-xs text-muted-eff truncate">{it.email} · {new Date(it.created_at).toLocaleDateString("fr-CA")}</div>
            </div>
            <EffSelect testid={`submission-status-${i}`} size="sm" className="w-[130px]" value={it.status}
              onChange={(v) => setStatus(it.id, v)}
              options={STATUSES.map((s) => ({ value: s, label: s }))} />
            <button onClick={() => remove(it.id)} className="text-muted-eff hover:text-white"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
        {items.length === 0 && <Empty label="Aucune proposition." />}
      </div>
      )}

      {open && (
        <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex justify-end" onClick={() => setOpen(null)}>
          <div className="w-full max-w-lg h-full bg-black border-l border-[#292929] overflow-y-auto p-6" onClick={(e) => e.stopPropagation()}>
            <div className="text-xs tracking-widest uppercase text-muted-eff mb-6">Proposition</div>
            {[["Nom", open.name], ["Email", open.email], ["Téléphone", open.phone], ["Projet", open.project_name], ["Type", open.type], ["Description", open.description], ["Besoins", open.needs], ["Instagram / site", open.social]].map(([k, v]) => (
              <div key={k} className="mb-4">
                <div className="text-[10px] tracking-widest uppercase text-muted-eff">{k}</div>
                <div className="text-sm mt-1 whitespace-pre-wrap">{v || "—"}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
